// src/components/AdminRoute.jsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';

const AdminRoute = () => {
  const { user, loading } = useAuth();

  // console.log('ADMIN ROUTE >>>', { user, loading });

  // While auth state is being resolved, don't decide yet
  if (loading) {
    return <div>Loading...</div>; // or a spinner component
  }

  // Not logged in → send to login
  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  // Logged in but not admin → send to unauthorized page
  if (user.role !== 'admin') {
    return <Navigate to="/unauthorized" replace />;
  }

  // Logged in & admin → render nested admin routes
  return <Outlet />;
};

export default AdminRoute;
